const HELP_DOMAINS = ["xn--80aftjjbe.online", "помогай.online", "localhost"];
const BRIGADE_DOMAINS = ["dispatcherpro.ru", "www.dispatcherpro.ru"];

export type ProductDomain = "help" | "brigade";

export function getProductDomain(): ProductDomain {
  const host = window.location.hostname;
  if (BRIGADE_DOMAINS.some((d) => host === d || host.endsWith("." + d)))
    return "brigade";
  return "help";
}

export const isHelpDomain = () => getProductDomain() === "help";
export const isBrigadeDomain = () => getProductDomain() === "brigade";
